export const LOYALTY_RANK_TAG_STATUSES = {
  progress: "loyalty.rank.tag.progress",
  nextRank: "loyalty.rank.tag.nextRank",
  collected: "loyalty.rank.tag.collected",
};
